import api from "@/api/axios.js";

export async function loadOrgTree()
{
	try
	{
		const {data} = await api.get("/api/orgnodes");
		return data?.items || [];
	}
	catch
	{
		return [];
	}
}

export async function loadOrgRoot()
{
	try
	{
		const {data} = await api.get("/api/orgnodes/root");
		return data?.node || null;
	}
	catch
	{
		return null;
	}
}

export async function createNode(body)
{
	try
{
		const {data} = await api.post("/api/orgnodes", body); // { parentKey:"root", name } oppure { parentId, name }
		return data;
	}
	catch (e)
	{
		return {ok: false, error: e.response?.data?.error || e.message};
	}
}

export async function renameNode(id, name)
{
	try
	{
		const {data} = await api.patch(`/api/orgnodes/${id}`, {name});
		return data;
	}
	catch (e)
	{
		return {ok: false, error: e.response?.data?.error || e.message};
	}
}

export async function updateAllowedProductFields(id, allowedProductFields)
{
	try
	{
		const {data} = await api.put(`/api/orgnodes/${id}/allowed-product-fields`, {allowedProductFields});
		return data;
	}
	catch (e)
	{
		return {ok: false, error: e.response?.data?.error || e.message};
	}
}

export async function deleteNode(id)
{
	try
	{
		const {data} = await api.delete(`/api/orgnodes/${id}`);
		return data;
	}
	catch (e)
	{
		return {ok: false, error: e.response?.data?.error || e.message};
	}
}

export async function getRootAiDescriptions()
{
	try
	{
		const {data} = await api.get("/api/orgnodes/root/ai-descriptions");
		return data;
	}
	catch (e)
	{
		return {ok: false, error: e.response?.data?.error || e.message};
	}
}

export async function updateRootAiDescriptions(descriptions)
{
	try
	{
		const {data} = await api.put("/api/orgnodes/root/ai-descriptions", {descriptions});
		return data;
	}
	catch (e)
	{
		return {ok: false, error: e.response?.data?.error || e.message};
	}
}

export async function getCooperativaAiDescriptions(cooperativaId)
{
	try
	{
		const {data} = await api.get(`/api/orgnodes/${cooperativaId}/ai-descriptions`);
		return data;
	}
	catch (e)
	{
		return {ok: false, error: e.response?.data?.error || e.message};
	}
}

export async function updateCooperativaAiDescription(cooperativaId, fieldName, customDescription)
{
	try
	{
		const {data} = await api.put(`/api/orgnodes/${cooperativaId}/ai-descriptions/${encodeURIComponent(fieldName)}`, {customDescription});
		return data;
	}
	catch (e)
	{
		return {ok: false, error: e.response?.data?.error || e.message};
	}
}

export async function updateCooperativaAiEnabled(cooperativaId, fieldName, enabled)
{
	try
	{
		const {data} = await api.put(`/api/orgnodes/${cooperativaId}/ai-enabled/${encodeURIComponent(fieldName)}`, {enabled});
		return data;
	}
	catch (e)
	{
		return {ok: false, error: e.response?.data?.error || e.message};
	}
}

export async function updateCooperativaAiModel(cooperativaId, model)
{
	try
	{
		const {data} = await api.put(`/api/orgnodes/${cooperativaId}/ai-model`, {model});
		return data;
	}
	catch (e)
	{
		return {ok: false, error: e.response?.data?.error || e.message};
	}
}

// Modello AI globale delle impostazioni: serve solo a mostrare cosa eredita una cooperativa
// senza override. In caso di errore la UI mostra semplicemente "eredita dal globale".
export async function loadGlobalAiModel()
{
	try
	{
		const {data} = await api.get("/api/settings");
		const model = data?.settings?.ai?.defaultModel;
		return typeof model === "string" ? model.trim() : "";
	}
	catch
	{
		return "";
	}
}
